import { APERCU_PRO } from '@alveolemtl/alveole-components/dist/lib/fonts';
import { createTheme } from '@mui/material/styles';
// import { makeStyles } from '@mui/styles';

const colors = {
  palette: {
    yellow: '#FFD43A',
    lightYellow: '#FFEDAD',
    orange: '#FE9D35',
    lightOrange: '#FED7AD',
    green: '#2EDB4B',
    lightGreen: '#D1FFD9',
    blue: '#34AFF7',
    lightBlue: '#B0DCFF',
    red: '#FF5252',
    lightRed: '#FFB8B8',
    teal: '#26A69A',
    purple: '#6200EE',
    myhiveGreen: '#58827F',
  },
  lightWarning: '#FFD0D0',
  warning: '#E53E3E',
  gray: {
    900: '#1A202C',
    800: '#2D3648',
    700: '#4A5468',
    600: '#717D96',
    500: '#A0ABC0',
    400: '#CBD2E0',
    300: '#E2E7F0',
    200: '#EDF0F7',
    100: '#F7F9FC',
  },
};

export enum AvailableApercuWeight {
  Bold = 700,
  Medium = 500,
  Regular = 400,
  Light = 300,
}

function toRem(pixel: number, rootFontSize = 16): string {
  return `${pixel / rootFontSize}rem`;
}

const fontSizes = {
  xs: toRem(12),
  sm: toRem(14),
  md: toRem(16),
  lg: toRem(18),
  xl: toRem(20),
};

declare module '@mui/material/styles/createTypography' {
  interface TypographyOptions {
    xs: CSSProperties;
    sm: CSSProperties;
    md: CSSProperties;
    lg: CSSProperties;
    xl: CSSProperties;
  }
}
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
  }
}

export const theme = createTheme({
  typography: {
    fontFamily: APERCU_PRO,
    h1: {
      fontSize: '48px',
      fontWeight: AvailableApercuWeight.Bold,
    },
    h2: {
      fontSize: '40px',
      fontWeight: AvailableApercuWeight.Bold,
    },
    h3: {
      fontSize: '24px',
      fontWeight: AvailableApercuWeight.Medium,
    },
    subtitle1: {
      fontSize: '14px',
      fontWeight: AvailableApercuWeight.Regular,
    },
    body1: {
      fontSize: '16px',
      fontWeight: AvailableApercuWeight.Regular,
    },
    xs: {
      color: colors.gray[800],
      fontSize: fontSizes.xs,
      lineHeight: '150%',
    },
    sm: {
      color: colors.gray[800],
      fontSize: fontSizes.sm,
      lineHeight: '150%',
      letterSpacing: '-0.14px',
    },
    md: {
      color: colors.gray[800],
      fontSize: fontSizes.md,
      lineHeight: '150%',
      letterSpacing: '-0.16px',
    },
    lg: {
      color: colors.gray[800],
      fontSize: fontSizes.lg,
      lineHeight: '150%',
      letterSpacing: '-0.18px',
    },
    xl: {
      color: colors.gray[800],
      fontSize: fontSizes.xl,
      lineHeight: '160%',
      letterSpacing: '-0.22px',
    },
  },
  palette: {
    text: {
      primary: '#2B2A2B',
      secondary: '#717171',
    },
    //@ts-expect-error  project explainer is broken if you dont add the below
    myhiveGreen: {
      dark: '#104f55',
    },
  },
});

// const useStyles = makeStyles({
//   tabs: {
//     pt: 2,
//     color: '#2D3648',
//     borderBottomWidth: 0,
//     '& .Mui-selected': {
//       color: '#2D3648 !important',
//       backgroundColor: 'white',
//       borderRadius: 2,
//       px: 1.5,
//       border: "solid 1px #dfe0e3"
//     },
//     '& .MuiTabs-indicator': {
//       backgroundColor: '#2D3648',
//       borderWidth: 0,
//       visibility: 'hidden'
//     }
//   }
// });

// const classes = useStyles();

// <Tabs
//   className={classes.tabs}
//   value={nestedTab}
//   onChange={handleNestedTabChange}
//   variant="scrollable"
//   scrollButtons="auto"
// >
